import React, { useEffect } from "react";
import { getScore } from "service/draft";
import { applyBoxPreferences } from "common/utils";
import { CharacterBox } from "types/Player/type";

type UsePlayerScorePlayer = {
  characters?: CharacterBox[];
  preferences?: {
    sheetId: number;
    characters: CharacterBox[];
  }[];
};

export const usePlayerScore = (
  player: UsePlayerScorePlayer | undefined,
  sheetId: number | undefined,
  setScore: React.Dispatch<React.SetStateAction<number | undefined>>,
) => {
  useEffect(() => {
    if (!player || sheetId === undefined) {
      setScore(undefined);
      return;
    }

    let cancelled = false;

    const fetchScore = async () => {
      const preferences = player.preferences?.find(
        (p) => p.sheetId === sheetId,
      )?.characters;
      const score = await getScore(
        applyBoxPreferences(player.characters ?? [], preferences),
        sheetId,
      );
      if (!cancelled) {
        setScore(score);
      }
    };

    fetchScore();

    return () => {
      cancelled = true;
    };
  }, [player, sheetId, setScore]);
};
